import { deserialize } from "bson"

const tradingSections = {
    main: { key: 'main', name: 'Main Options', },
    // extra: { key: 'extra', name: 'Extra Options', },


}

const tradingPages = {


    // attributes

    tequipments: {
        key: 'tequipments',
        title: 'Sell Equipments Listing Summary',
        description: 'Trading List',
        fetchUrl: 'getAllTEquipments',
        fetchOne: 'getOneTEquipments',
        addUrl: 'postTEquipments',
        editUrl: 'postTEquipments',
        convertUrl: 'addRentalFromSell',
        removeUrl: 'removeTEquipments',
        pageType: 'form',
        parent: 'main',
        // populate: ["category", 'brand'],
        populate: ["category", 'brand', 'owner', 'country'],
        options: { noAddNew: true },
        addNew: -1,
        postBody: {
            category: { $nin: ['6746abd2daae3c36361ef262'] }
        },
        // extra: { export: { url: 'ExelTradingEquipment', name: 'export', function: 'openExport', icon: '/images/eye.svg' }, import: { schema: 'tradingEquipments', name: 'import', function: 'openImport', icon: '/images/eye.svg' } },
        // importAPIName: [{ key: 'category', title: "name", schema: 'categories', isTree: true, treeKey: 'parent' }, { key: 'brand', title: "name", schema: 'brands', canImport: true }, { key: 'owner', title: "userId", schema: 'users' }, { key: 'city', title: "name", schema: 'places', isArray: true }, { key: 'currency', title: "currency", schema: 'countries' }, { key: 'country', title: "name", schema: 'countries' }, { key: 'tequipmentId', app: 'tequipments', key: 'tequipmentId', isAutoGen: true }],
        // {key:'city',title:"name", schema: 'places',isArray: true},
        extra: { export: { url: 'ExelTradingEquipment', name: 'export', function: 'openExport', icon: '/images/eye.svg' }, import: { schema: 'tradingEquipments', name: 'import', function: 'openImport', icon: '/images/eye.svg' } },
        importAPIName: [{ key: 'category', title: "name", value: '_id', schema: 'categories', isTree: true, treeKey: 'parent' }, { key: 'model', helpingKey: 'category', title: "model", secondtTitle: 'slug', value: 'model', schema: 'wikis', secondKey: 'catalogue', secondValue: 'catalogue', thirdKey: 'attributes', thirdValue: 'attributes' }, { key: 'brand', title: "name", value: '_id', schema: 'brands', canImport: true }, { key: 'owner', title: "userId", value: '_id', schema: 'users' }, { key: 'city', title: "name", value: '_id', schema: 'places', parentKey: 'mainAddress' }, { key: 'address', parentKey: 'mainAddress', isAddress: true, secondKey: 'location', thirdKey: 'postalCode', forthKey: 'country' }, { key: 'currency', title: "name", value: '_id', schema: 'countries' }, { key: 'country', title: "name", value: '_id', schema: 'countries' }, { key: 'tequipmentId', app: 'tequipments', isAutoGen: true }],

        tabs: [
            // { title: 'Pending', filter: { "status": '0' } },
            { title: 'Pending', filter: { "active": '0' } },
            { title: 'Need Review', filter: { 'importError': { $exists: true, $ne: "" } } },
        ],

        // page: 'tequipments',
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: "openEditModal", permission: 'view' },

            convertToSell: { key: "convert", label: '{{lang}}Convert To Rental', disableLable: '{{lang}}Can Not Become A Rental', unSelectableLable: '{{lang}}Already A Rental', condition: 'rentalEq', color: '#677dc4', function: "openConvertionModal", permission: 'create' },


            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },


        image: '/images/covers/2.jpg',
        convertHeaders: [




            { type: 'SelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, hideInList: true, showMain: false },

            {
                key: 'city', type: 'MultiSelectInput', col: '6', information: { label: 'City', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getPlaces', filter: { country: '' } },
                dependencies: [{
                    refKey: 'country',
                    targetKey: 'city',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: true }, operator: { value: '==' }, target: { value: true } }
                            }
                        }
                    },
                    show: false,
                    init: true,
                    changeHeader: { key: 'information.filter.country', value: '@data.country' }
                }],
                settings: { required: true }, showMain: false, fullCol: true
            },

            { key: 'price.daily', type: 'PriceInput', col: '6', information: { label: 'Daily Price', }, showMain: true, inExport: true },
            { key: 'price.weekly', type: 'PriceInput', col: '6', information: { label: 'Weekly Price', }, showMain: true, inExport: true },
            { key: 'price.monthly', type: 'PriceInput', col: '6', information: { label: 'Monthly Price', }, showMain: true, inExport: true },
            { key: 'price.delivery', type: 'PriceInput', col: '6', information: { label: 'Delivery Price', }, showMain: true, inExport: true },

            { key: 'onlySelfPickup', type: 'SwitchInput', col: '6', information: { label: 'Only Self Pickup', required: false }, showMain: false },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: 'Description', }, settings: { disabled: true }, fullCol: true, showMain: false },

            { key: 'active', type: 'SelectInput', col: '6', information: { label: 'Active', placeholder: 'Select ...', type: 'local', default: '0', items: [{ title: "Not Active", value: '0' }, { title: 'Active', value: '1' }, { title: "Rejected", value: '-1' }, { title: "Blocked By Admin", value: '-2' },] }, settings: { required: true }, showMain: true, inExport: true },
            { key: 'featured', type: 'SwitchInput', col: '6', information: { label: 'Featured', required: false }, showMain: false },
            { key: 'recommended', type: 'SwitchInput', col: '6', information: { label: 'Recommended', required: false }, showMain: false },

            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: 'Description', }, showMain: false, inExport: true },
            { key: 'note', type: 'TextAreaInput', col: '6', information: { label: 'Note', }, showMain: false, },
            // { type: 'DateInput', key: 'certExpDate', col: '6', information: { label: 'CERT Expire Date', }, showMain: false, },
            { key: 'unavailable', type: 'SwitchInput', col: '6', information: { label: 'Available', invert: true, required: false }, showMain: true, inExport: true },
            //{ col: '6', key: 'certFile', type: 'FileInput', information: { label: 'LE CERT File', single: true }, showMain: false, fullCol: false },


        ],
        headers: [

            { key: 'tequipmentId', type: 'TextInput', information: { label: 'Equipment Id', disabled: true }, showMain: true, settings: { disabled: true }, fullCol: true, inExport: true, disabled: true },

            // { type: 'TextInput', key: 'title', information: { label: 'Title', }, showMain: true, inExport: true },

            { key: 'image', type: 'ImageInput', information: { label: 'Marketplace Image', single: false, cropper: true, ratio: '1:1' }, showMain: true, fullCol: true },
            { key: 'webstoreImage', type: 'ImageInput', information: { label: 'Webstore Image', single: false, cropper: true, ratio: '1:1' }, showMain: false, fullCol: true },

            // { key: 'creator.company', type: 'TextInput', col: '6', information: { label: 'Company', }, showMain: true, settings: { disabled: true }, fullCol: true, hideInList: true, inExport: true },

            // { key: 'owner', type: 'SelectInput', col: '6', information: { label: 'Owner', type: 'api', fields: { value: '_id', title: 'company' }, address: 'getUsers', filter: {}, linkInfo: { ref: "users", loader: "isPostingData", } }, settings: { required: true, url: '/users/getOneFilter', page: 'users', showInfo: true, disabled: true }, showMain: false },
            { key: 'cDate', type: 'DateInput', col: '6', information: { label: 'Creation Date', disabled: true }, showMain: true, inExport: true },
            { key: 'owner', type: 'SelectInput', col: '6', information: { label: 'Owner', type: 'api', fields: { value: '_id', title: 'company', description: 'email' }, address: 'getUsers', filter: { country: "*" }, linkInfo: { ref: "users", loader: "isPostingData", } }, settings: { required: true, url: '/users/getOneFilter', page: 'users', showInfo: true, disabled: true }, showMain: true, inExport: true },
            {
                key: 'category', type: 'MultiTreeSelectAddListing', col: '6', information: { label: 'Category', type: 'api', startPoint: null, root: null, reference: 'parent', fields: { value: '_id', title: 'name', image: 'image', parent: 'parent' }, address: 'getCategories', filter: { "sort": { 'priority': -1 }, select: { body: 0 }, filter: { "deactive": { $ne: true }, "$and": [{ '$or': [{ onlyFor: '1' }, { onlyFor: null }] }] } } }, settings: { required: true },
                dependencies: [{
                    refKey: 'country',
                    targetKey: 'category',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: true }, operator: { value: '==' }, target: { value: true } }
                            }
                        }
                    },
                    show: false,
                    init: false,
                    changeHeader: { key: 'information.filter.country', value: '@data.country' },
                    //  changeValue: {
                    //         targetKey: "city",
                    //         value: null,
                    //         conditions: {
                    //             root: {
                    //                 id: 'root',
                    //                 action: 'and',
                    //                 conditions: {
                    //                     1: { id: 1, source: { value: '@data.country' }, operator: { value: '!=' }, target: { value: null } }
                    //                 }
                    //             },
                    //         },
                    //     }
                }],
                showMain: true, fullCol: true, inExport: true
            },

            { key: 'brand', type: 'SelectInput', col: '6', information: { label: 'Brand', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getBrands', filter: {} }, showMain: false, inExport: true },
            { key: 'model', type: 'TextInput', col: '6', information: { label: 'Model', }, showMain: true, inExport: true },
            { key: 'condition', type: 'SelectInput', col: '6', information: { label: 'Condition', type: 'local', default: '0', items: [{ title: 'New', value: "new" }, { title: 'Used', value: "used" }, { title: 'Scrap', value: "scrap" }] }, settings: { required: true }, showMain: true, inExport: true },
            { type: 'CalendarRental', col: '6', key: 'year', information: { alignCenter: true, extraOption: 'Brand New', label: 'Manufacture Year', placeholder: 'Input Year', required: false }, showMain: true },
            { type: 'TextInput', key: 'title', information: { label: 'Title', }, showMain: true, inExport: true },

            { type: 'TextAreaInput', key: 'description', information: { label: 'Description', }, showMain: false, fullCol: true },
            { key: 'showPrice', type: 'SelectInput', col: '6', information: { label: 'Price Type', type: 'local', default: 'hasPrice', items: [{ title: "Exact Price", value: 'hasPrice' }, { title: 'Price From', value: 'rangePrice' }, { title: "Hide Price (R.F.Q)", value: 'noPrice' }] }, settings: { required: false }, showMain: true },

            {
                key: 'minPrice', type: 'PriceInput', col: '6', information: { label: 'Minimum Price', },
                dependencies: [{
                    refKey: 'showPrice',
                    targetKey: 'minPrice',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.showPrice' }, operator: { value: '==' }, target: { value: 'rangePrice' } }
                            }
                        }
                    },
                    show: false,
                    // init: true,
                    // changeHeader: {  }
                }],
                showMain: true, inExport: true
            },
            // {
            //     key: 'maxPrice', type: 'PriceInput', col: '6', information: { label: 'Maximum Price', },
            //     dependencies: [{
            //         refKey: 'showPrice',
            //         targetKey: 'maxPrice',
            //         conditions: {
            //             root: {
            //                 id: 'root',
            //                 action: 'or',
            //                 conditions: {
            //                     1: { id: 1, source: { value: '@data.showPrice' }, operator: { value: '==' }, target: { value: 'rangePrice' } }
            //                 }
            //             }
            //         },
            //         show: false,
            //         // init: true,
            //         // changeHeader: {  }
            //     }],
            //     showMain: true, inExport: true
            // },
            { key: 'price', type: 'PriceInput', col: '6', information: { label: 'Price', }, showMain: true, inExport: true },
            { type: 'SelectInput', key: 'currency', col: '6', information: { label: 'Currency', type: 'api', fields: { value: '_id', title: 'currency' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: true, inExport: true },



            { key: 'deliveryWeekly', type: 'SelectInput', information: { label: 'Deliver Lead Time', type: 'local', items: [{ title: 'Ready For Deliver', value: "readyfordeliver" }, { title: '1 Week', value: "1 Week" }, { title: '2 Week', value: "twoWeek" }, { title: '3 Week', value: "threeWeek" }, { title: '4 Week', value: "fourWeek" }, { title: '2 Months', value: "twoMonths" }, { title: '3 Months', value: "threeMonths" }], placeholder: 'Deliver Lead Time', required: false } },
            // { key: 'year', type: 'NumberInput', col: '6', information: { label: 'Year of manufacturing', }, showMain: false, fullCol: true, inExport: true },

            { key: 'serialNumber', type: 'TextInput', col: '6', information: { label: 'Serial Number', }, showMain: false, fullCol: true, inExport: true },
            // { type: '', key: 'serialNumber', showMain: true, information: { required: true, label: translate('Serial Number'), placeholder: translate('Input Serial Number'), icon: '/img/icons/Pen.png' } },

            { key: 'workingHour', type: 'NumberInput', col: '6', information: { label: 'working hour', }, showMain: false, fullCol: true, inExport: true },
            // { key: 'values.serialNumber', type: 'TextInput', col: '6', information: { label: 'Serial Number', }, showMain: true, inExport: true },
            { type: 'SelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: true, inExport: true },

            {
                key: 'mainAddress.city', type: 'SelectInput', col: '6', information: { label: 'City', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getPlaces', filter: {} },
                dependencies: [{
                    refKey: 'mainAddress.location',
                    targetKey: 'mainAddress.city',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: true }, operator: { value: '==' }, target: { value: true } }
                            }
                        }
                    },
                    show: false,
                    init: true,
                    changeHeader: { key: 'information.filter.country', value: '@data.country._id' }
                }],
                settings: { required: true }, showMain: false, fullCol: true, inExport: true
            },

            // { type: 'SelectInput', key: 'mainAddress.city', information: { label: 'City', placeholder: 'City ...', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getPlaces', filter: { country: '{{country}}' }, required: false }, showMain: true },

            { type: 'TextInput', key: 'mainAddress.address', information: { label: 'Address', placeholder: 'Full Address', required: false }, showMain: false },
            { type: 'TextInput', key: 'mainAddress.postalCode', col: '6', information: { label: 'zip code', placeholder: 'zip code / postal code', required: false }, showMain: false },
            // { type: 'TextInput', key: 'mainAddress.project', col: '6', information: { label: 'Project Name', placeholder: 'Project Name', required: true }, showMain: true },

            { type: 'MapInput', key: 'mainAddress.location', col: '12', information: { label: 'location', placeholder: 'Project Name', required: false, country: '', notRestricted: true, mainAddress: true, canChangeCountry: true }, showMain: false },


            // { key: 'category', type: 'MultiLevelInput', col: '6', information: { label: 'Category', type: 'api', startPoint: null, root: null, reference: 'parent', fields: { value: '_id', title: 'name' }, address: 'getCategories', filter: { country: '{{country}}' } }, settings: { required: true }, showMain: true, fullCol: true, inExport: true },,
            // { key: 'category', type: 'MultiLevelInput', col: '6', information: { label: 'Category', type: 'api', startPoint: null, root: null, reference: 'parent', fields: { value: '_id', title: 'name' }, address: 'getCategories', filter: { country: "*" ,'$or': [{ onlyFor: '1' }, { onlyFor: null }]} }, settings: { required: true }, showMain: true, fullCol: true, inExport: true },
            // { key: 'place', type: 'MultiLevelInput', col: '6', information: { label: 'place', type: 'api', startPoint: null, root: '', reference: 'values.parent', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'tplaces' } }, settings: { required: true }, showMain: true, fullCol: true, inExport: true },



            // { key: 'place', type: 'MultiSelectInput', col: '6', information: { label: 'Place', type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'tplaces' } }, settings: { required: true }, showMain: false, fullCol: true },

            // { key: 'values.price.daily', type: 'PriceInput', col: '6', information: { label: 'Daily Price', }, showMain: true, inExport: true },
            // { key: 'values.price.weekly', type: 'PriceInput', col: '6', information: { label: 'Weekly Price', }, showMain: true, inExport: true },
            // { key: 'values.price.monthly', type: 'PriceInput', col: '6', information: { label: 'Monthly Price', }, showMain: true, inExport: true },




            ///// dependencies
            {
                type: 'AttributesLoader',
                key: 'attributes',
                ref: 'category',
                information: { label: 'Attributes', inputClass: 'transparent-input', refKey: 'categories', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getAttributes', filter: { country: '*' } },
                showMain: false,
                fullCol: true,
                // dependencies: [{ type: 'filter', dontRefresh: true, action: 'enable', field: 'category', param: 'categories' }],
                col: '12',
                dependencies: [{
                    refKey: 'category',
                    targetKey: 'attributes',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: "1" } }
                            }
                        },
                    },
                    show: true,
                    init: true,
                    // changeValue: {
                    //     targetKey: "latitude",
                    //     value: null,
                    //     conditions: {
                    //         root: {
                    //             id: 'root',
                    //             action: 'and',
                    //             conditions: {
                    //                 1: { id: 1, source: { value: '@data.settings.haslLocation' }, operator: { value: '==' }, target: { value: false } }
                    //             }
                    //         },
                    //     },
                    // }
                    changeHeader: { key: 'information.refValue', value: '@data.category', },

                }],

            },
            // {
            //     type: 'AttributesLoader',
            //     key: 'attributes',
            //     ref: 'category',
            //     information: { label: 'Attributes', inputClass: 'transparent-input', refKey: 'categories', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getAll', filter: { page: 'tattributes' } },
            //     showMain: false,
            //     fullCol: true,
            //     col: '12',
            //     dependencies: [{
            //         refKey: 'category',
            //         targetKey: 'attributes',
            //         conditions: {
            //             root: {
            //                 id: 'root',
            //                 action: 'and',
            //                 conditions: {
            //                     1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: "1" } }
            //                 }
            //             },
            //         },
            //         show: true,
            //         init: true,

            //         changeHeader: { key: 'information.refValue', value: '@data.category', },

            //     }],

            // },

            // { key: 'values.wiki', type: 'SelectInput', col: '6', information: { label: 'Wiki', type: 'api', fields: { value: 'values.slug', title: 'values.model' }, address: 'getAll', filter: { page: 'wiki', sort: { 'values.model': 1 } } }, showMain: false },


            // { key: 'workingHour', type: 'NumberInput', col: '6', information: { label: 'Working Hour', }, showMain: true, inExport: true },
            { key: 'defects', type: 'TextAreaInput', col: '12', information: { label: 'defects declaration', }, showMain: false, inExport: true },
            // { key: 'condition', type: 'SelectInput', col: '6', information: { label: 'Condition', type: 'local', default: '0', items: [{ title: "Used", value: 'Used' }, { title: 'New', value: 'New' }, { title: 'Scrap', value: 'scrap' }] }, settings: { required: true }, showMain: true, inExport: true },
            { key: 'status', type: 'SelectInput', col: '6', information: { label: 'Status (User)', type: 'local', default: '0', items: [{ title: "Pending", value: '0' }, { title: 'Active', value: '1' }, { title: "Rejected", value: '-1' },] }, settings: { required: true }, showMain: true, inExport: true },

            { key: 'active', type: 'SelectInput', col: '6', information: { label: 'Active (Admin)', placeholder: 'Select ...', type: 'local', default: '0', items: [{ title: "Not Active", value: '0' }, { title: 'Active', value: '1' }, { title: "Rejected", value: '-1' }, { title: "Blocked By Admin", value: '-2' },] }, settings: { required: true }, showMain: true, inExport: true },
            { key: 'activeOnlyFor', type: 'SelectInput', col: '6', information: { label: 'Active Only For', placeholder: 'Select ...', type: 'local', items: [{ title: "Main Website", value: 'Main' }, { title: 'Web Store', value: 'Store' }, { title: "Main Website & Web Store", value: 'Main&Store' }] }, showMain: true, inExport: true },

            { key: 'sellFeatured', type: 'SelectInput', col: '6', information: { label: 'Featured', type: 'local', items: [{ title: "Featured 1", value: 'Featured1' }, { title: 'Featured 2', value: 'Featured2' }] }, settings: { required: true }, showMain: true, inExport: true },
            // { key: 'sellFeatured', type: 'SwitchInput', col: '6', information: { label: 'Featured', required: false }, showMain: false },
            { key: 'sellRecommended', type: 'SwitchInput', col: '6', information: { label: 'Recommended', required: false }, showMain: false },
            // { key: 'removed', type: 'SwitchInput', col: '6', information: { label: 'removed', required: false }, showMain: false },


            //// Invert
            // { key: 'values.unavailable', type: 'SwitchInput', col: '6', information: { label: 'Available', invert: true, required: false }, showMain: true, inExport: true },

            { key: 'sold', type: 'SwitchInput', col: '6', information: { label: 'Sold', }, showMain: false, inExport: true },

            { key: 'catalogue', type: 'FileInput', col: '12', information: { label: 'Catalogue', single: false }, showMain: false, fullCol: true, settings: { required: true }, },

            { type: 'TextAreaInput', key: 'importError', information: { label: 'Need Review', }, showMain: false, fullCol: true },
            { key: 'remark', type: 'TextAreaInput', col: '12', information: { label: 'Admin Remark', }, showMain: true, },

            // { type: 'DateInput', key: 'values.certExpDate', col: '6', information: { label: 'CERT Expire Date', }, showMain: false, },
            // { col: '6', key: 'values.certFile', type: 'FileInput', information: { label: 'LE CERT File', single: true }, showMain: false, fullCol: false },

        ]
    },
    spareParts: {
        key: 'spareParts',
        title: 'Spare Parts',
        description: 'Spare Parts List',
        fetchUrl: 'getAllTEquipments',
        fetchOne: 'getOneTEquipments',
        addUrl: 'postTEquipments',
        editUrl: 'postTEquipments',
        convertUrl: 'addRentalFromSell',
        removeUrl: 'removeTEquipments',
        pageType: 'form',
        parent: 'main',
        // populate: ["category", 'brand'],
        populate: ["category", 'brand', 'owner', 'country'],
        options: { noAddNew: true },
        addNew: -1,
        postBody: {
            category: { $in: ['6746abd2daae3c36361ef262'] }
        },
        // extra: { export: { url: 'ExelTradingEquipment', name: 'export', function: 'openExport', icon: '/images/eye.svg' }, import: { schema: 'tradingEquipments', name: 'import', function: 'openImport', icon: '/images/eye.svg' } },
        // importAPIName: [{ key: 'category', title: "name", schema: 'categories', isTree: true, treeKey: 'parent' }, { key: 'brand', title: "name", schema: 'brands', canImport: true }, { key: 'owner', title: "userId", schema: 'users' }, { key: 'city', title: "name", schema: 'places', isArray: true }, { key: 'currency', title: "currency", schema: 'countries' }, { key: 'country', title: "name", schema: 'countries' }, { key: 'tequipmentId', app: 'tequipments', key: 'tequipmentId', isAutoGen: true }],
        // {key:'city',title:"name", schema: 'places',isArray: true},
        extra: { export: { url: 'ExelTradingEquipment', name: 'export', function: 'openExport', icon: '/images/eye.svg' }, import: { schema: 'tradingEquipments', name: 'import', function: 'openImport', icon: '/images/eye.svg' } },
        importAPIName: [{ key: 'category', title: "name", value: '_id', schema: 'categories', isTree: true, treeKey: 'parent' }, { key: 'model', helpingKey: 'category', title: "model", secondtTitle: 'slug', value: 'model', schema: 'wikis', secondKey: 'catalogue', secondValue: 'catalogue', thirdKey: 'attributes', thirdValue: 'attributes' }, { key: 'brand', title: "name", value: '_id', schema: 'brands', canImport: true }, { key: 'owner', title: "userId", value: '_id', schema: 'users' }, { key: 'city', title: "name", value: '_id', schema: 'places', parentKey: 'mainAddress' }, { key: 'address', parentKey: 'mainAddress', isAddress: true, secondKey: 'location', thirdKey: 'postalCode', forthKey: 'country' }, { key: 'currency', title: "name", value: '_id', schema: 'countries' }, { key: 'country', title: "name", value: '_id', schema: 'countries' }, { key: 'tequipmentId', app: 'tequipments', isAutoGen: true }],

        tabs: [
            // { title: 'Pending', filter: { "status": '0' } },
            { title: 'Pending', filter: { "active": '0' } },
            { title: 'Need Review', filter: { 'importError': { $exists: true, $ne: "" } } },
        ],

        // page: 'tequipments',
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: "openEditModal", permission: 'view' },

            convertToSell: { key: "convert", label: '{{lang}}Convert To Rental', disableLable: '{{lang}}Can Not Become A Rental', unSelectableLable: '{{lang}}Already A Rental', condition: 'rentalEq', color: '#677dc4', function: "openConvertionModal", permission: 'create' },


            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },


        image: '/images/covers/2.jpg',
        convertHeaders: [




            { type: 'SelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, hideInList: true, showMain: false },

            {
                key: 'city', type: 'MultiSelectInput', col: '6', information: { label: 'City', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getPlaces', filter: { country: '' } },
                dependencies: [{
                    refKey: 'country',
                    targetKey: 'city',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: true }, operator: { value: '==' }, target: { value: true } }
                            }
                        }
                    },
                    show: false,
                    init: true,
                    changeHeader: { key: 'information.filter.country', value: '@data.country' }
                }],
                settings: { required: true }, showMain: false, fullCol: true
            },

            { key: 'price.daily', type: 'PriceInput', col: '6', information: { label: 'Daily Price', }, showMain: true, inExport: true },
            { key: 'price.weekly', type: 'PriceInput', col: '6', information: { label: 'Weekly Price', }, showMain: true, inExport: true },
            { key: 'price.monthly', type: 'PriceInput', col: '6', information: { label: 'Monthly Price', }, showMain: true, inExport: true },
            { key: 'price.delivery', type: 'PriceInput', col: '6', information: { label: 'Delivery Price', }, showMain: true, inExport: true },

            { key: 'onlySelfPickup', type: 'SwitchInput', col: '6', information: { label: 'Only Self Pickup', required: false }, showMain: false },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: 'Description', }, settings: { disabled: true }, fullCol: true, showMain: false },

            { key: 'active', type: 'SelectInput', col: '6', information: { label: 'Active', placeholder: 'Select ...', type: 'local', default: '0', items: [{ title: "Not Active", value: '0' }, { title: 'Active', value: '1' }, { title: "Rejected", value: '-1' }, { title: "Blocked By Admin", value: '-2' },] }, settings: { required: true }, showMain: true, inExport: true },
            { key: 'featured', type: 'SwitchInput', col: '6', information: { label: 'Featured', required: false }, showMain: false },
            { key: 'recommended', type: 'SwitchInput', col: '6', information: { label: 'Recommended', required: false }, showMain: false },

            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: 'Description', }, showMain: false, inExport: true },
            { key: 'note', type: 'TextAreaInput', col: '6', information: { label: 'Note', }, showMain: false, },
            // { type: 'DateInput', key: 'certExpDate', col: '6', information: { label: 'CERT Expire Date', }, showMain: false, },
            { key: 'unavailable', type: 'SwitchInput', col: '6', information: { label: 'Available', invert: true, required: false }, showMain: true, inExport: true },
            //{ col: '6', key: 'certFile', type: 'FileInput', information: { label: 'LE CERT File', single: true }, showMain: false, fullCol: false },


        ],
        headers: [

            { key: 'tequipmentId', type: 'TextInput', information: { label: 'Equipment Id', }, showMain: true, settings: { disabled: true }, fullCol: true, inExport: true },

            // { type: 'TextInput', key: 'title', information: { label: 'Title', }, showMain: true, inExport: true },

            { key: 'image', type: 'ImageInput', information: { label: 'Marketplace Image', single: false, cropper: true, ratio: '1:1' }, showMain: true, fullCol: true },
            { key: 'webstoreImage', type: 'ImageInput', information: { label: 'Webstore Image', single: false, cropper: true, ratio: '1:1' }, showMain: false, fullCol: true },

            // { key: 'creator.company', type: 'TextInput', col: '6', information: { label: 'Company', }, showMain: true, settings: { disabled: true }, fullCol: true, hideInList: true, inExport: true },

            // { key: 'owner', type: 'SelectInput', col: '6', information: { label: 'Owner', type: 'api', fields: { value: '_id', title: 'company' }, address: 'getUsers', filter: {}, linkInfo: { ref: "users", loader: "isPostingData", } }, settings: { required: true, url: '/users/getOneFilter', page: 'users', showInfo: true, disabled: true }, showMain: false },
            { key: 'cDate', type: 'DateInput', col: '6', information: { label: 'Creation Date', disabled: true }, showMain: true, inExport: true },
            { key: 'owner', type: 'SelectInput', col: '6', information: { label: 'Owner', type: 'api', fields: { value: '_id', title: 'company', description: 'email' }, address: 'getUsers', filter: { country: "*" }, linkInfo: { ref: "users", loader: "isPostingData", } }, settings: { required: true, url: '/users/getOneFilter', page: 'users', showInfo: true, disabled: true }, showMain: true, inExport: true },
            {
                key: 'category', type: 'MultiTreeSelectAddListing', col: '6', information: { label: 'Category', type: 'api', startPoint: null, root: null, reference: 'parent', fields: { value: '_id', title: 'name', image: 'image', parent: 'parent' }, address: 'getCategories', filter: { "sort": { 'priority': -1 }, select: { body: 0 }, filter: { "deactive": { $ne: true }, "$and": [{ '$or': [{ onlyFor: '1' }, { onlyFor: null }] }] } } }, settings: { required: true },
                dependencies: [{
                    refKey: 'country',
                    targetKey: 'category',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: true }, operator: { value: '==' }, target: { value: true } }
                            }
                        }
                    },
                    show: false,
                    init: false,
                    changeHeader: { key: 'information.filter.country', value: '@data.country' },
                    //  changeValue: {
                    //         targetKey: "city",
                    //         value: null,
                    //         conditions: {
                    //             root: {
                    //                 id: 'root',
                    //                 action: 'and',
                    //                 conditions: {
                    //                     1: { id: 1, source: { value: '@data.country' }, operator: { value: '!=' }, target: { value: null } }
                    //                 }
                    //             },
                    //         },
                    //     }
                }],
                showMain: true, fullCol: true, inExport: true
            },

            { key: 'brand', type: 'SelectInput', col: '6', information: { label: 'Brand', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getBrands', filter: {} }, showMain: false, inExport: true },
            { key: 'model', type: 'TextInput', col: '6', information: { label: 'Model', }, showMain: true, inExport: true },
            { key: 'condition', type: 'SelectInput', col: '6', information: { label: 'Condition', type: 'local', default: '0', items: [{ title: 'New', value: "new" }, { title: 'Used', value: "used" }, { title: 'Scrap', value: "scrap" }] }, settings: { required: true }, showMain: true, inExport: true },
            { type: 'CalendarRental', col: '6', key: 'year', information: { alignCenter: true, extraOption: 'Brand New', label: 'Manufacture Year', placeholder: 'Input Year', required: false }, showMain: true },
            { type: 'TextInput', key: 'title', information: { label: 'Title', }, showMain: true, inExport: true },

            { type: 'TextAreaInput', key: 'description', information: { label: 'Description', }, showMain: false, fullCol: true },
            { key: 'showPrice', type: 'SelectInput', col: '6', information: { label: 'Price Type', type: 'local', default: 'hasPrice', items: [{ title: "Exact Price", value: 'hasPrice' }, { title: 'Price From', value: 'rangePrice' }, { title: "Hide Price (R.F.Q)", value: 'noPrice' }] }, settings: { required: false }, showMain: true },

            {
                key: 'minPrice', type: 'PriceInput', col: '6', information: { label: 'Minimum Price', },
                dependencies: [{
                    refKey: 'showPrice',
                    targetKey: 'minPrice',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.showPrice' }, operator: { value: '==' }, target: { value: 'rangePrice' } }
                            }
                        }
                    },
                    show: false,
                    // init: true,
                    // changeHeader: {  }
                }],
                showMain: true, inExport: true
            },
            // {
            //     key: 'maxPrice', type: 'PriceInput', col: '6', information: { label: 'Maximum Price', },
            //     dependencies: [{
            //         refKey: 'showPrice',
            //         targetKey: 'maxPrice',
            //         conditions: {
            //             root: {
            //                 id: 'root',
            //                 action: 'or',
            //                 conditions: {
            //                     1: { id: 1, source: { value: '@data.showPrice' }, operator: { value: '==' }, target: { value: 'rangePrice' } }
            //                 }
            //             }
            //         },
            //         show: false,
            //         // init: true,
            //         // changeHeader: {  }
            //     }],
            //     showMain: true, inExport: true
            // },
            { key: 'price', type: 'PriceInput', col: '6', information: { label: 'Price', }, showMain: true, inExport: true },
            { type: 'SelectInput', key: 'currency', col: '6', information: { label: 'Currency', type: 'api', fields: { value: '_id', title: 'currency' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: true, inExport: true },



            { key: 'deliveryWeekly', type: 'SelectInput', information: { label: 'Deliver Lead Time', type: 'local', items: [{ title: 'Ready For Deliver', value: "readyfordeliver" }, { title: '1 Week', value: "1 Week" }, { title: '2 Week', value: "twoWeek" }, { title: '3 Week', value: "threeWeek" }, { title: '4 Week', value: "fourWeek" }, { title: '2 Months', value: "twoMonths" }, { title: '3 Months', value: "threeMonths" }], placeholder: 'Deliver Lead Time', required: false } },
            // { key: 'year', type: 'NumberInput', col: '6', information: { label: 'Year of manufacturing', }, showMain: false, fullCol: true, inExport: true },

            { key: 'serialNumber', type: 'TextInput', col: '6', information: { label: 'Serial Number', }, showMain: false, fullCol: true, inExport: true },
            // { type: '', key: 'serialNumber', showMain: true, information: { required: true, label: translate('Serial Number'), placeholder: translate('Input Serial Number'), icon: '/img/icons/Pen.png' } },

            { key: 'workingHour', type: 'NumberInput', col: '6', information: { label: 'working hour', }, showMain: false, fullCol: true, inExport: true },
            // { key: 'values.serialNumber', type: 'TextInput', col: '6', information: { label: 'Serial Number', }, showMain: true, inExport: true },
            { type: 'SelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: true, inExport: true },

            {
                key: 'mainAddress.city', type: 'SelectInput', col: '6', information: { label: 'City', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getPlaces', filter: {} },
                dependencies: [{
                    refKey: 'mainAddress.location',
                    targetKey: 'mainAddress.city',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: true }, operator: { value: '==' }, target: { value: true } }
                            }
                        }
                    },
                    show: false,
                    init: true,
                    changeHeader: { key: 'information.filter.country', value: '@data.country._id' }
                }],
                settings: { required: true }, showMain: false, fullCol: true, inExport: true
            },

            // { type: 'SelectInput', key: 'mainAddress.city', information: { label: 'City', placeholder: 'City ...', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getPlaces', filter: { country: '{{country}}' }, required: false }, showMain: true },

            { type: 'TextInput', key: 'mainAddress.address', information: { label: 'Address', placeholder: 'Full Address', required: false }, showMain: false },
            { type: 'TextInput', key: 'mainAddress.postalCode', col: '6', information: { label: 'zip code', placeholder: 'zip code / postal code', required: false }, showMain: false },
            // { type: 'TextInput', key: 'mainAddress.project', col: '6', information: { label: 'Project Name', placeholder: 'Project Name', required: true }, showMain: true },

            { type: 'MapInput', key: 'mainAddress.location', col: '12', information: { label: 'location', placeholder: 'Project Name', required: false, country: '', notRestricted: true, mainAddress: true, canChangeCountry: true }, showMain: false },


            // { key: 'category', type: 'MultiLevelInput', col: '6', information: { label: 'Category', type: 'api', startPoint: null, root: null, reference: 'parent', fields: { value: '_id', title: 'name' }, address: 'getCategories', filter: { country: '{{country}}' } }, settings: { required: true }, showMain: true, fullCol: true, inExport: true },,
            // { key: 'category', type: 'MultiLevelInput', col: '6', information: { label: 'Category', type: 'api', startPoint: null, root: null, reference: 'parent', fields: { value: '_id', title: 'name' }, address: 'getCategories', filter: { country: "*" ,'$or': [{ onlyFor: '1' }, { onlyFor: null }]} }, settings: { required: true }, showMain: true, fullCol: true, inExport: true },
            // { key: 'place', type: 'MultiLevelInput', col: '6', information: { label: 'place', type: 'api', startPoint: null, root: '', reference: 'values.parent', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'tplaces' } }, settings: { required: true }, showMain: true, fullCol: true, inExport: true },



            // { key: 'place', type: 'MultiSelectInput', col: '6', information: { label: 'Place', type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'tplaces' } }, settings: { required: true }, showMain: false, fullCol: true },

            // { key: 'values.price.daily', type: 'PriceInput', col: '6', information: { label: 'Daily Price', }, showMain: true, inExport: true },
            // { key: 'values.price.weekly', type: 'PriceInput', col: '6', information: { label: 'Weekly Price', }, showMain: true, inExport: true },
            // { key: 'values.price.monthly', type: 'PriceInput', col: '6', information: { label: 'Monthly Price', }, showMain: true, inExport: true },




            ///// dependencies
            {
                type: 'AttributesLoader',
                key: 'attributes',
                ref: 'category',
                information: { label: 'Attributes', inputClass: 'transparent-input', refKey: 'categories', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getAttributes', filter: { country: '*' } },
                showMain: false,
                fullCol: true,
                // dependencies: [{ type: 'filter', dontRefresh: true, action: 'enable', field: 'category', param: 'categories' }],
                col: '12',
                dependencies: [{
                    refKey: 'category',
                    targetKey: 'attributes',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: "1" } }
                            }
                        },
                    },
                    show: true,
                    init: true,
                    // changeValue: {
                    //     targetKey: "latitude",
                    //     value: null,
                    //     conditions: {
                    //         root: {
                    //             id: 'root',
                    //             action: 'and',
                    //             conditions: {
                    //                 1: { id: 1, source: { value: '@data.settings.haslLocation' }, operator: { value: '==' }, target: { value: false } }
                    //             }
                    //         },
                    //     },
                    // }
                    changeHeader: { key: 'information.refValue', value: '@data.category', },

                }],

            },
            // {
            //     type: 'AttributesLoader',
            //     key: 'attributes',
            //     ref: 'category',
            //     information: { label: 'Attributes', inputClass: 'transparent-input', refKey: 'categories', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getAll', filter: { page: 'tattributes' } },
            //     showMain: false,
            //     fullCol: true,
            //     col: '12',
            //     dependencies: [{
            //         refKey: 'category',
            //         targetKey: 'attributes',
            //         conditions: {
            //             root: {
            //                 id: 'root',
            //                 action: 'and',
            //                 conditions: {
            //                     1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: "1" } }
            //                 }
            //             },
            //         },
            //         show: true,
            //         init: true,

            //         changeHeader: { key: 'information.refValue', value: '@data.category', },

            //     }],

            // },

            // { key: 'values.wiki', type: 'SelectInput', col: '6', information: { label: 'Wiki', type: 'api', fields: { value: 'values.slug', title: 'values.model' }, address: 'getAll', filter: { page: 'wiki', sort: { 'values.model': 1 } } }, showMain: false },


            // { key: 'workingHour', type: 'NumberInput', col: '6', information: { label: 'Working Hour', }, showMain: true, inExport: true },
            { key: 'defects', type: 'TextAreaInput', col: '12', information: { label: 'defects declaration', }, showMain: false, inExport: true },
            // { key: 'condition', type: 'SelectInput', col: '6', information: { label: 'Condition', type: 'local', default: '0', items: [{ title: "Used", value: 'Used' }, { title: 'New', value: 'New' }, { title: 'Scrap', value: 'scrap' }] }, settings: { required: true }, showMain: true, inExport: true },
            { key: 'status', type: 'SelectInput', col: '6', information: { label: 'Status (User)', type: 'local', default: '0', items: [{ title: "Pending", value: '0' }, { title: 'Active', value: '1' }, { title: "Rejected", value: '-1' },] }, settings: { required: true }, showMain: true, inExport: true },

            { key: 'active', type: 'SelectInput', col: '6', information: { label: 'Active (Admin)', placeholder: 'Select ...', type: 'local', default: '0', items: [{ title: "Not Active", value: '0' }, { title: 'Active', value: '1' }, { title: "Rejected", value: '-1' }, { title: "Blocked By Admin", value: '-2' },] }, settings: { required: true }, showMain: true, inExport: true },
            { key: 'activeOnlyFor', type: 'SelectInput', col: '6', information: { label: 'Active Only For', placeholder: 'Select ...', type: 'local', items: [{ title: "Main Website", value: 'Main' }, { title: 'Web Store', value: 'Store' }, { title: "Main Website & Web Store", value: 'Main&Store' }] }, showMain: true, inExport: true },

            { key: 'sellFeatured', type: 'SelectInput', col: '6', information: { label: 'Featured', type: 'local', items: [{ title: "Featured 1", value: 'Featured1' }, { title: 'Featured 2', value: 'Featured2' }] }, settings: { required: true }, showMain: true, inExport: true },
            // { key: 'sellFeatured', type: 'SwitchInput', col: '6', information: { label: 'Featured', required: false }, showMain: false },
            { key: 'sellRecommended', type: 'SwitchInput', col: '6', information: { label: 'Recommended', required: false }, showMain: false },
            // { key: 'removed', type: 'SwitchInput', col: '6', information: { label: 'removed', required: false }, showMain: false },


            //// Invert
            // { key: 'values.unavailable', type: 'SwitchInput', col: '6', information: { label: 'Available', invert: true, required: false }, showMain: true, inExport: true },

            { key: 'sold', type: 'SwitchInput', col: '6', information: { label: 'Sold', }, showMain: false, inExport: true },

            { key: 'catalogue', type: 'FileInput', col: '12', information: { label: 'Catalogue', single: false }, showMain: false, fullCol: true, settings: { required: true }, },

            { type: 'TextAreaInput', key: 'importError', information: { label: 'Need Review', }, showMain: false, fullCol: true },
            { key: 'remark', type: 'TextAreaInput', col: '12', information: { label: 'Admin Remark', }, showMain: true, },

            // { type: 'DateInput', key: 'values.certExpDate', col: '6', information: { label: 'CERT Expire Date', }, showMain: false, },
            // { col: '6', key: 'values.certFile', type: 'FileInput', information: { label: 'LE CERT File', single: true }, showMain: false, fullCol: false },

        ]
    },



    // trequests: {
    //     key: "trequests",
    //     title: 'Trading Requests',
    //     fetchUrl: 'getAllTRequests',
    //     addUrl: 'postTRequest',
    //     editUrl: 'postTRequest',
    //     removeUrl: 'removeTRequest',
    //     pageType: 'form',
    //     // page: 'trequests',
    //     options: { noAddNew: true },
    //     addNew: -1,
    //     parent: 'main',
    //     image: '/images/covers/1.jpg',
    //     tabs: [
    //         { title: 'Pending', filter: { "status": '0' } },
    //         { title: 'In Progress', filter: { "status": '1' } },
    //         { title: 'Finished', filter: { "status": '2' } },
    //         // { title: 'Canceled', filter: { "status": '-1' } },
    //     ],

    //     headers: [
    //         { key: 'trequestId', type: 'TextInput', information: { label: 'Request Id', disabled: true, }, showMain: true, settings: { disabled: true }, fullCol: true, inExport: true },

    //         { type: 'TextInput', key: 'name', col: '6', information: { label: 'Name', }, showMain: true },
    //         { type: 'TextInput', key: 'phone', col: '6', information: { label: 'Phone', }, showMain: true },
    //         { type: 'TextAreaInput', key: 'description', information: { label: 'Description', }, showMain: true },
    //         { type: 'TextAreaInput', key: 'remark', information: { label: 'Remark', }, showMain: true },
    //         { key: 'status', type: 'SelectInput', col: '6', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "Pending", value: '0' }, { title: 'In Progress', value: '1' }, { title: 'Finished', value: '2' }, { title: "Canceled", value: '-1' }, ] }, settings: { required: true }, showMain: true, inExport: true },

    //         { key: 'equipment', type: 'SelectInput', col: '6', information: { label: 'Equipment', type: 'api', fields: { value: '_id', title: 'tequipmentId' }, address: 'getAllTEquipments', filter: {}, linkInfo: { ref: "tequipments", loader: "isPostingData", } }, showMain: false },
    //         { key: 'creator', type: 'SelectInput', col: '6', information: { label: 'Requester', type: 'api', fields: { value: '_id', title: 'values.company' }, address: 'getUsers', filter: {} }, settings: { required: true, url: '/users/getOneFilter', page: 'users', showInfo: true, disabled: true }, showMain: false, inExport: true },

    //         // { type: 'SelectInput', key: 'values.country', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'countries' } }, settings: { required: true }, showMain: false },

    //     ],
    // },
    ticketing: {
        key: 'ticketing',
        title: 'Order Requests',
        description: 'Ticketing list',
        fetchUrl: 'getTickets',
        addUrl: 'postTicket',
        removeUrl: 'removeTicket',
        fetchOneUrl: 'getOneTicket',
        addOneUrl: 'postTicketReply',

        pageType: 'list',
        parent: 'main',
        tab: [
            { key: 'user', title: 'User' },
            { key: 'partner', title: 'Partner' }
        ],
        options: {},
        sort: { 'values.priority': -1 },
        image: '/images/back1.jpg',
        headers: [
            // { key: 'user', type: 'AdvancedSelectInput', col: "6", information: { label: '{{lang}}User', address: 'getUsers', filter: {}, fields: { title: 'phone', description: "fullname", image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}user', required: true }, showMain: true },

            // { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true } },
            // { key: 'id', type: 'TextInput', information: { label: '{{lang}}Id', placeholder: '{{lang}}Id', required: false } },

            { key: 'body', type: 'TextInput', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
            { key: 'title', type: 'TextInput', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
            // { key: 'values.parent', type: 'TextInput', information: { label: '{{lang}}parent', placeholder: '{{lang}}parent', required: false } },
            // { type: 'SelectInput', key: 'values.parent', col: '12', information: { label: '{{lang}}parent', address: 'getContents', filter: { page: 'DocumentsCategories' }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select ...', required: false }, showMain: false },
            // { key: 'values.priority', type: 'NumberInput', information: { label: '{{lang}}priority', placeholder: '{{lang}}priority', required: false } },

            { type: 'SelectInput', key: 'status', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: '{{lang}}Pending' }, { value: '2', title: '{{lang}}Waiting for answer' }, { value: '3', title: '{{lang}}Answered' }, { value: '-1', title: '{{lang}}Closed' }], isSearchable: true, placeholder: '{{lang}}Status', required: true }, showMain: true },

        ]
    },
    recyclebin: {
        key: 'recyclebin',
        title: 'Removed Order Requests',
        description: 'trash list',
        fetchUrl: 'getRemovedTickets',
        addUrl: 'postTicket',
        removeUrl: 'restoreTicket',
        fetchOneUrl: 'getOneTicket',
        addOneUrl: 'postTicketReply',

        pageType: 'list',
        parent: 'main',

        options: {},
        sort: { 'values.priority': -1 },
        image: '/images/back1.jpg',
        headers: [
            // { key: 'user', type: 'AdvancedSelectInput', col: "6", information: { label: '{{lang}}User', address: 'getUsers', filter: {}, fields: { title: 'phone', description: "fullname", image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}user', required: true }, showMain: true },

            // { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true } },
            // { key: 'id', type: 'TextInput', information: { label: '{{lang}}Id', placeholder: '{{lang}}Id', required: false } },

            { key: 'body', type: 'TextInput', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
            { key: 'title', type: 'TextInput', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
            // { key: 'values.parent', type: 'TextInput', information: { label: '{{lang}}parent', placeholder: '{{lang}}parent', required: false } },
            // { type: 'SelectInput', key: 'values.parent', col: '12', information: { label: '{{lang}}parent', address: 'getContents', filter: { page: 'DocumentsCategories' }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select ...', required: false }, showMain: false },
            // { key: 'values.priority', type: 'NumberInput', information: { label: '{{lang}}priority', placeholder: '{{lang}}priority', required: false } },

            { type: 'SelectInput', key: 'status', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: '{{lang}}Pending' }, { value: '2', title: '{{lang}}Waiting for answer' }, { value: '3', title: '{{lang}}Answered' }, { value: '-1', title: '{{lang}}Closed' }], isSearchable: true, placeholder: '{{lang}}Status', required: true }, showMain: true },

        ]
    },

    faq: {
        key: 'faq',
        title: 'FAQs',
        description: 'Frequently Asked Questions',
        fetchUrl: 'getAll',
        addUrl: 'addValue',
        editUrl: 'addValue',
        removeUrl: 'removeValue',
        pageType: 'form',
        page: 'faq',
        parent: 'main',
        image: '/images/covers/1.jpg',
        sort: { 'values.priority': 1 },
        hasTranslation: true,
        postBody: { "values.source": 'trading' },
        headers: [
            { type: 'TextAreaInput', key: 'values.title', information: { label: 'Question', }, hasTranslation: true, showMain: true },
            { key: 'values.type', type: 'SelectInput', information: { label: 'Type', type: 'local', items: [{ title: "For Users", value: 'users' }, { title: 'For Partners', value: 'partners' }] }, settings: { required: true }, showMain: true },
            { type: 'NumberInput', key: 'values.priority', information: { label: 'Priority', }, showMain: true },
            // { type: 'MultiSelectInput', key: 'values.country', col: '6', information: { label: 'Country', showAllInTable: true, type: 'api', fields: { value: 'slug', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: true },
            { type: 'MultiSelectInput', key: 'values.pages', col: '6', information: { label: '{{lang}}Pages', showAllInTable: true, type: 'local', items: [{ value: 'home', title: 'Home' }, { value: 'howtobuy', title: 'How to buy' }, { value: 'howtosell', title: 'How to sell' }, { value: 'faq', title: 'FAQ Page' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },

            // { title: 'Description', type: 'TextInput', key: 'values.description', showMain: true },
            // { title: 'Url', type: 'TextInput', key: 'values.address', showMain: true },
            { type: 'EditorInput', key: 'values.body', information: { label: 'Answer', }, hasTranslation: true, showMain: false, fullCol: true },

        ],
    },

    rental: {
        key: 'ordersTicketing',
        title: 'Submitted Orders',
        description: 'Orders list',
        fetchUrl: 'tradingOrdersAll',
        addUrl: 'tradingOrdersAdd',
        editUrl: 'tradingOrdersAdd',
        removeUrl: 'tradingOrdersRemove',
        // options: { noAddNew: true },
        // helperKey: 'values',
        pageType: 'form',
        parent: 'main',
        options: {},
        // sort: { 'cDate': -1 },
        addNew: -1,
        image: '/images/covers/1.jpg',
        extra: { export: { url: 'rentalExcelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        postBody: { archived: { $ne: true } },
        populate: ["category"],
        indicators: {
            filter: [
                [{ key: "status" }, '==', '0']
            ],
            color: '#f7f9ff',
            borderColor: '#fff0f0'
        },

        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: "openEditModal", permission: 'view' },
            // PDF: { key: "PDF", label: '{{lang}}Download Insurance PDF', color: '#677dc4', function: "downloadInsurancePDF", permission: 'view' },
            // extendTime: { key: "extendTime", label: '{{lang}}Extend Rental Time', color: '#677dc4', function: "extendRentalTime", permission: 'edit' },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },


        tabs: [
            { title: 'Reserved', filter: { "status": '0' } },
            { title: 'Finished', filter: { "status": '3' } },
        ],




        headers: [

            { col: '6', key: 'status', type: 'SelectInput', fullCol: true, information: { label: 'Status', required: true, type: 'local', default: '0', items: [{ title: "Reserved", value: '0' }, { title: "Waiting For Delivery", value: '1' }, { title: 'Finished', value: '3', color: '#fff', backgroundColor: '#00CD74' }, { title: 'Cancelled By Requester', value: '10' }, { title: 'Cancelled By Ownner', value: '11' }] }, showMain: true, inExport: true },
            // { col: '6', key: 'paymentStatus', type: 'SelectInput', fullCol: true, information: { label: 'Status', required: true, type: 'local', default: '0', items: [{ title: "Pending", value: '0' }, { title: "Done", value: '1' }, { title: 'In rental', value: '2' }, { title: 'Need Payment', value: '3', color: '#fff', backgroundColor: '#00CD74' }, { title: 'Cancelled By Requester', value: '10' }, { title: 'Cancelled By Ownner', value: '11' }] }, showMain: true, inExport: true },
            // { version: null,col:'6', key: 'paymentStatus', type: 'StatusIndicator', thirdCol: true, information: { label: 'Payments', type: 'local', default: '0', relatedKey: 'paymentsList', items: [{ title: "Pending", value: '0', color: '#eee' }, { title: 'Done', value: '1', color: '#00C9A7' }, { title: 'Need Payment', value: '2', color: '#FF7D9D' }, { title: 'EXPIRED', value: '3', color: '#FF7D9D' }] }, showMain: true },
            { col: '6', key: 'cDate', type: 'DateInput', information: { label: 'Reservation date', }, showMain: true, hideInList: true },
            { key: 'price', type: 'PriceInput', col: '6', information: { label: 'Price', }, showMain: true, inExport: true },
            { col: '12', key: 'description', type: 'TextAreaInput', information: { label: 'Description', }, showMain: false },
            { col: '6', key: 'product', type: 'SelectInput', information: { label: 'Equipment', type: 'api', fields: { value: '_id', title: 'tequipmentId' }, address: 'getAllTEquipments', filter: {}, linkInfo: { ref: "tequipments", loader: "isPostingData", } }, showMain: false },
            // { col: '6', key: 'customer', type: 'TextInput', information: { label: 'customer', }, showMain: true, settings: { disabled: true }, hideInList: true },
            { col: '6', key: 'customer', type: 'SelectInput', information: { label: "User's Company", type: 'api', fields: { value: '_id', title: 'company', description: 'name' }, address: 'getUsers', filter: {}, linkInfo: { ref: "users", loader: "isPostingData", } }, showMain: false, disabled: true, inExport: true },


        ],






    },




    // tcategories: {
    //     key: 'tcategories',
    //     title: 'Trading Equipment Category',
    //     description: 'Trading Categories List',
    //     fetchUrl: 'getAll',
    //     addUrl: 'addValue',
    //     editUrl: 'addValue',
    //     removeUrl: 'removeValue',
    //     pageType: 'form',
    //     page: 'tcategories',
    //     parent: 'main',
    //     image: '/images/covers/4.jpg',
    //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    //     // populate: ["parent"],

    //     headers: [
    //         { type: 'TextInput', key: 'values.name', col: '6', information: { label: 'Name', }, showMain: true, inExport: true },
    //         { type: 'TextInput', key: 'values.slug', col: '6', information: { label: 'Slug', }, showMain: true, inExport: true },
    //         { key: 'values.image', type: 'ImageInput', col: '12', information: { label: 'Image', single: true, cropper: true }, showMain: true, fullCol: true },

    //         { type: 'NumberInput', key: 'values.priority', col: '6', information: { label: 'Priority', }, showMain: false },

    //         //////// hideInList
    //         { type: 'NumberInput', key: 'values.count', col: '6', information: { label: 'Count', }, showMain: true, hideInList: true, inExport: true },
    //         { type: 'SelectInput', key: 'values.parent', col: '6', information: { label: 'Parent', type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'tcategories' } }, settings: { required: false }, showMain: false, fullCol: true },

    //         { key: 'values.description', type: 'TextInput', col: '12', information: { label: 'Description', }, showMain: false, inExport: true },
    //         // { type: 'SwitchInput', key: 'values.withOperator', showMain: true, col: '6', information: { label: 'with operator', inExport: true } },
    //         // { type: 'SwitchInput', key: 'values.withoutInsurance', showMain: true, col: '6', information: { label: 'Without Insurance', inExport: true }, showMain: false },

    //         { type: 'EditorInput', key: 'values.body', information: { label: 'Body', }, showMain: false, fullCol: true },

    //         { key: 'values.deactive', type: 'SwitchInput', col: '6', information: { label: 'Deactive', }, showMain: true, },
    //         { key: 'values.multiple', type: 'SwitchInput', col: '6', information: { label: 'Multiple Available', }, showMain: true, },

    //         // { key: 'values.isSearchable', type: 'SwitchInput', col: '6', information: { label: 'Is searchable', }, showMain: true, },
    //         // { title: 'Edit', type: 'button', function: 'edit', options: { color: "#78b2d0" }, showMain: true }, { title: 'Remove', type: 'button', function: 'remove', options: { color: "#dd8aa4" }, showMain: true }
    //     ],
    // },



    // tattributes: {
    //     key: 'tattributes',
    //     title: 'Trading Equipment Specification',
    //     description: 'Trading Equipment Specification List',
    //     fetchUrl: 'getAll',
    //     addUrl: 'addValue',
    //     editUrl: 'addValue',
    //     removeUrl: 'removeValue',
    //     pageType: 'form',
    //     page: 'tattributes',
    //     parent: 'extra',
    //     image: '/images/covers/6.jpg',
    //     // populate: ["categories"],

    //     headers: [
    //         { type: 'TextInput', key: 'values.name', information: { label: 'Name', }, showMain: true },
    //         { type: 'MultiSelectInput', key: 'values.categories', information: { label: 'Categories', tag: false, type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'tcategories' } }, settings: { required: true }, showMain: false },
    //         // { type: 'NumberInput', key: 'values.min', col: '6', information: { label: 'Min', }, showMain: true },
    //         // { type: 'NumberInput', key: 'values.max', col: '6', information: { label: 'Max', }, showMain: true },
    //         // { type: 'NumberInput', key: 'values.steps', col: '6', information: { label: 'Steps', }, showMain: false },
    //         { type: 'NumberInput', key: 'values.min', col: '6', information: { label: 'Min', }, showMain: true },
    //         { type: 'NumberInput', key: 'values.max', col: '6', information: { label: 'Max', }, showMain: true },
    //         { type: 'NumberInput', key: 'values.steps', col: '6', information: { label: 'Steps', }, showMain: false },

    //         { type: 'TextInput', key: 'values.suffix', col: '6', information: { label: 'Suffix', }, showMain: true },
    //         // { type: 'SwitchInput', key: 'values.isEditableInWiki', col: '6', information: { label: 'Is Editable In Wiki', }, showMain: false },


    //     ],
    // },






    // tplaces: {
    //     key: "tplaces",
    //     title: 'Trading Places',
    //     fetchUrl: 'getAll',
    //     addUrl: 'addValue',
    //     editUrl: 'addValue',
    //     removeUrl: 'removeValue',
    //     pageType: 'form',
    //     page: 'tplaces',
    //     parent: 'extra',
    //     image: '/images/covers/1.jpg',
    //     headers: [
    //         { type: 'TextInput', key: 'values.name', col: '6', information: { label: 'Name', }, showMain: true },
    //         { type: 'SelectInput', key: 'values.parent', col: '6', information: { label: 'Parent', type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'tplaces' } }, settings: { required: false }, showMain: false, fullCol: true },

    //         // { type: 'SelectInput', key: 'values.country', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'countries' } }, settings: { required: true }, showMain: false },

    //     ],
    // },




    // tlogs: {
    //     key: "tlogs",
    //     title: 'Trading Logs',
    //     description: 'Trading Logs List',
    //     fetchUrl: 'getInbox',
    //     // addUrl: 'addEmployee',
    //     // editUrl: 'addEmployee',
    //     // removeUrl: 'removeEmployee',
    //     pageType: 'form',
    //     page: 'logs',
    //     parent: 'admin',
    //     addNew: -1,
    //     options: { noAddNew: true },
    //     actions: {},
    //     tabs: [
    //         { title: 'Admins', filter: { "role": 'admin' } },
    //         { title: 'Users', filter: { "role": 'user' } },

    //     ],

    //     image: '/images/covers/1.jpg',
    //     headers: [
    //         { type: 'TextInput', key: 'message', information: { label: 'Message', }, showMain: true },
    //         { type: 'DateInput', key: 'cDate', information: { label: 'Date/Time', time: true }, showMain: true },

    //         { type: 'TextInput', key: 'type', information: { label: 'Type', }, showMain: true },

    //     ],
    // },





}


export { tradingPages, tradingSections }